module.exports = __webpack_public_path__ + "4ccbe6eb.svg";